import { useEffect } from 'react';
import { AddFlowForm } from '@/features/email-flows/components/add-flow';
import { useGlobalStore } from '@/stores';
import { MENUITEM_IDS } from '@/lib';

export default function AddFlowPage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);

    // Set breadcrumbs
    useEffect(() => {
        setBreadcrumbs([
            { title: 'My Email Flows', to: '/flows', id: MENUITEM_IDS.FLOWS, active: false },
            { title: 'Add Flow', to: '/flows/new', id: '', active: true },
        ]);
    }, [setBreadcrumbs]);

    return <AddFlowForm />;
}
